import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  ...theme.paddings(15),
  gap: 15,
  backgroundColor: theme.palette.white,
  borderRadius: 4,
  boxShadow: `0 1px 5px ${theme.palette.shadow.medium}`,
}));

export const BlockTitle = styled("h3")(({ theme }) => ({
  color: "#787878",
  borderBottom: "1px solid #ababab87",
  fontWeight: 400,
  paddingBottom: 10,
}));

export const PaymentMethodsBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  gap: 10,
  // display: "grid",
  // gridTemplateColumns: "repeat(4, 1fr)",
  // gap: 5,

  // [theme.down("xl")]: {
  //   gridTemplateColumns: "repeat(3, 1fr)",
  // },

  // [theme.down("sm")]: {
  //   gridTemplateColumns: "repeat(2, 1fr)",
  // },

  // [theme.down("xs")]: {
  //   gridTemplateColumns: "1fr",
  // },
}));

export const PaymentMethodItem = styled("div")(({ theme, $isActive }) => ({
  ...theme.mixins.flexColumn,
  ...theme.paddings(10),
  gap: 5,
  justifyContent: "center",
  alignItems: "flex-start",
  position: "relative",
  backgroundColor: $isActive ? "#f8fbff" : theme.palette.white,
  border: `1px solid ${$isActive ? "#4a90e2" : theme.palette.border.darker}`,
  borderRadius: 8,
  cursor: "pointer",
  transition: "all .3s ease-out",

  "& .balance-icon": {
    display: "flex",
    fontSize: 32,
  },

  "& .balance-not-enough": {
    ...theme.mixins.flexCenterCenter,
    fontSize: 12,
    color: theme.palette.searchButtonBg,
  },

  "&:hover": {
    borderColor: "#4a90e2",
    boxShadow: "0 2px 8px rgba(74, 144, 226, 0.15)",
  },
}));

export const PaymentMethodCheckboxBlock = styled("div")(({ theme }) => ({
  position: "absolute",
  right: 5,
  top: "center",
}));

export const PaymentMethodLogoContainer = styled("div")(({ theme }) => ({
  width: 90,
  height: 48,

  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const PaymentMethodLogo = styled("img")(({ theme }) => ({
  width: "100%",
  height: "auto",
  display: "block",
  maxWidth: 90,
  maxHeight: 48,

  [theme.down("xs")]: {
    maxWidth: 80,
  },
}));

export const PaymentMethodDescription = styled("div")(({ theme, $isActive }) => ({
  fontSize: 14,
  fontWeight: 600,
  color: $isActive ? theme.palette.text.primary : theme.palette.text.muted,
}));

export const TimelimitAndPaymentButtonBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  flexDirection: "column",
  gap: 10,
  fontSize: 14,
  color: theme.palette.text.primary,
}));

export const PaymentButton = styled("button")(({ theme, $isMuted }) => ({
  ...theme.mixins.flexCenterCenter,
  ...theme.paddings(0, 15),
  position: "relative",
  fontSize: 20,
  border: `.5px solid ${theme.palette.border.darker}`,
  borderRadius: 4,
  backgroundColor: $isMuted ? theme.palette.text.muted : theme.palette.headerBg,
  color: theme.palette.white,
  height: 46,
  width: "100%",
  cursor: $isMuted ? "not-allowed" : "pointer",
  pointerEvents: $isMuted ? "none" : "auto",

  transition: "all .3s ease-out",

  "&:hover": {
    backgroundColor: $isMuted ? theme.palette.text.muted : theme.palette.footerBg,
  },
}));

export const PaymentButtonLoadingCover = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: theme.palette.footerBg,
}));
